import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import LoginPage from './pages/loginPage';
import RegisterForm from './pages/RegisterPage';
import Home from './pages/Home';
import AboutUs from './pages/Aboutus';  
import Gallery from './pages/Gallery';
import Leadership from './pages/Leadership';
import Membership from './pages/Membership';
import LandingPage from './pages/Landingpage';
import { AuthProvider } from './context/AuthContext'; 
import Profile from './pages/profile';
import Paymentgateway1 from "./pages/Paymentgateway1";
import Paymentgateway2 from "./pages/Paymentgateway2";
import Manageusers from './pages/Managusers';
import Manageuser from './pages/Manageuser';
import Userprofile from './pages/Userprofile';
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Whatsnext from "./pages/Whatsnext";
import Help from "./pages/Help";







function App() {
  return (
    
    <AuthProvider> {/* Wrap in AuthProvider if using authentication */}
      <Router>
        <div className="App">
          <Header />
         
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterForm />} />
            <Route path="/aboutus" element={<AboutUs />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/leadership" element={<Leadership />} />
            <Route path="/landing" element={<LandingPage />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/paymentgateway1" element={<Paymentgateway1 />} />
            <Route path="/paymentgateway2" element={<Paymentgateway2 />} />
            <Route path="/manageusers" element={<Manageusers />} />
            <Route path="/membership" element={<Membership />} />
            <Route path="/manageuser" element={<Manageuser />} />
            <Route path="/userprofile" element={<Userprofile />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/whatsnext" element={<Whatsnext />} />
            <Route path="/help" element={<Help />} />
            
          
          </Routes>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
